import { AffiliateStatisticBaseInterface } from 'modules/affiliate/types/affiliate-statistic-interface'

export const getAffiliateActivity = (statistic: AffiliateStatisticBaseInterface) => ({
  hasCommissions: [
    statistic.total,
    statistic.today,
    statistic.last7Days,
    statistic.last30Days.sums,
    statistic.paidSums,
    statistic.pendingSums,
  ].some(sums => Object.values(sums).some(sum => sum !== 0)),
  hasLeads: statistic.totalLeads > 0,
})
